import { render, staticRenderFns } from "./LoginUser.vue?vue&type=template&id=885fa870&scoped=true"
import script from "./LoginUser.vue?vue&type=script&lang=js"
export * from "./LoginUser.vue?vue&type=script&lang=js"
import style0 from "./LoginUser.vue?vue&type=style&index=0&id=885fa870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885fa870",
  null
  
)

export default component.exports